<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <h4 class="card-title">Kategori Oluştur</h4>
              <p class="card-category">Elinizdeki ürünleri kategorilere ayırarak daha kolay yönetebilirsiniz.</p>
            </template>


            <form class="m-5">
              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Kategori Adı" placeholder="Kategori Adı" v-model="payload.name">
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <base-input type="text" label="Açıklama" placeholder="Açıklama" v-model="payload.description">
                  </base-input>
                </div>
              </div>


              <label>Üst Kategori Seçimi</label>
              <div class="row">
                <div class="col-md-4">
                  <select class="form-control" v-model="payload.parentCategory">
                    <option value="">Üst Kategori Seçiniz</option>
                    <option v-for="category in categories" :key="category._id" :value="category._id">
                      {{ category.name }}
                    </option>
                  </select>
                </div>
              </div>






              <div class="row pt-5">
                <div class="col-md-4">
                  <label>Aktif Mi?</label>
                  <base-checkbox type="text" label="Aktif" placeholder="Aktif" v-model="payload.isActive" :checked="payload.isActive" @click="payload.isActive = !payload.isActive">
                  </base-checkbox>
                </div>
              </div>



              <div class="text-center">
                <button type="submit" class="btn btn-info btn-fill float-right" @click="createNewCategory">
                  Oluştur
                </button>
              </div>
              <div class="clearfix"></div>
            </form>


          </card>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

export default {
  components: {
    Card
  },
  data() {
    return {
      payload: {
        name: "",
        isActive: true,
        description: "",
        parentCategory: null
      },
      categories: []
    }
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    createNewCategory() {
      CollectionService.postWidthAuth('category', this.payload).then((res) => {
        if (res.success == true) {
          this.notifyVue('bottom', 'right', 'success', "Kategori Oluşturuldu")
          this.$router.push(`/admin/categories`);
        } else {
          this.notifyVue('bottom', 'right', 'danger', res.body)
        }
      }).catch(err => {
        this.notifyVue('bottom', 'right', 'danger', err)
      })
    },
    getCategories() {

      CollectionService.getCollection('category').then((res) => {
        if (res.success == true) {
          this.categories = res.categories;
        } else {
          console.log('error');
        }
      })
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    }
  }
}
</script>
<style></style>